import { colors } from '@material-ui/core'

import constants from 'constants/index'

const chipStatusBgColor = (status) => {
  return (
    (status &&
      constants.settings.FINANCIAL_CHIP_STATUS_BACKGROUND_COLOR[status]) ||
    colors.blueGrey[100]
  )
}

export default chipStatusBgColor
